export default class OfferingAppointment {
    static fromData(data, duplicate = false) {
        if (!data) {
            return;
        }

        const appointment = new OfferingAppointment();

        appointment.id = data.id || null;
        appointment.start = data.start;
        appointment.end = data.end;
        appointment.interval = data.interval;
        appointment.intervalEnd = data.intervalEnd;
        appointment.weekday = data.weekday;

        if (duplicate) {
            // A duplicate is a new course, so it must not inherit the source season's end date:
            // moving the start into the new season then leaves start after intervalEnd, which the
            // server rejects as constraints.AppointmentSeries.startNotBeforeIntervalEnd.
            appointment.id = null;
            appointment.intervalEnd = null;
        }

        Object.seal(appointment);
        return appointment;
    }

    equals(appointment) {
        if (appointment.id === null) {
            return false;
        }
        return appointment.id === this.id;
    }
}
